/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PersonContextCto } from '../../models/person-context-cto';

export interface GetPerson$Json$Params {
  personGuid: string;
}

export function getPerson$Json(http: HttpClient, rootUrl: string, params: GetPerson$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PersonContextCto>> {
  const rb = new RequestBuilder(rootUrl, getPerson$Json.PATH, 'get');
  if (params) {
    rb.path('personGuid', params.personGuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PersonContextCto>;
    })
  );
}

getPerson$Json.PATH = '/person/{personGuid}';
